import { createContext, useContext } from "react";

import type { CreatedTemplate, Template } from "common/types";

import type { UseFormReturn } from "react-hook-form";
import type { FlowTemplate } from "../../../../types";

interface FlowTemplateContextType {
  flowTemplate: FlowTemplate;
  isRemoveButtonHidden: boolean;
  form: UseFormReturn<Template>;
  isEditing: boolean;

  // Methods
  handleSelectTemplate: (template: CreatedTemplate) => void;
  handleSave: () => void;
  handleDiscard: () => void;
  handleRemove: () => void;
  handleStartEdit: () => void;
}

const FlowTemplateContext = createContext<FlowTemplateContextType | undefined>(
  undefined,
);

export const FlowTemplateProvider = FlowTemplateContext.Provider;

export function useFlowTemplateContext() {
  const context = useContext(FlowTemplateContext);

  if (!context) {
    throw new Error(
      "useFlowTemplateContext must be used within a FlowTemplateProvider",
    );
  }

  return context;
}
